import type { FC } from 'react';
import { useEffect } from 'react';

import type { History, LocationState } from 'history';

import analytics from 'utils/analytics';

import { useAuth } from 'hooks/useAuth';

const AnalyticsIntegration: FC<{ history: History<LocationState> }> = ({ history }) => {
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    analytics.init(history, isAuthenticated).then(() => {
      if (user && isAuthenticated) {
        analytics.identify(user.id, {
          avatar: user.avatar,
          company: {
            id: user.company?.id,
            name: user.company?.name,
          },
          displayName: user.name,
          email: user.email,
          name: user.name,
          productName: 'dashboard',
          role: user.profile?.role,
        });
      }
    });
  }, [history, isAuthenticated, user]);

  return null;
};

export default AnalyticsIntegration;
